import { useQuery } from '@tanstack/react-query';
import { fetchLADClaimInitialValues } from '../data-provider/lad-claim-initial-values';

export const useGetLADClaimInitialValues = (companyId: number) => {
  return useQuery({
    queryKey: ['claims-loss-and-damage-create-claim-initial-values', companyId],
    queryFn: () => fetchLADClaimInitialValues(),
    staleTime: 1000 * 5, // 5 seconds (to avoid multiple calls)
    enabled: !!companyId,
  });
};
